import { Actor } from "../../models/Actor";
import {
  getActorAvatarColor,
  getActorAvatarInitial,
} from "../../helpers/actorAvatar";
import React from "react";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import classNames from "classnames";

interface ActorAvatarProps {
  actor?: Actor;
  size?: "24" | "36";
  theme?: "interaction" | "creator" | "creator-selected";
}

const ActorAvatar: React.FC<ActorAvatarProps> = ({
  actor,
  size = "36",
  theme = "interaction",
}) => {
  const isNamedActor = actor !== undefined && actor.id !== "player";
  const actorColor = isNamedActor ? getActorAvatarColor(actor) : "";
  const initial = isNamedActor
    ? getActorAvatarInitial(actor!.workingName)
    : actor?.id === "player"
      ? "P"
      : "";

  return (
    <div
      className={classNames({
        "flex my-auto rounded-full border-2 border-solid box-border items-center justify-center text-white font-medium":
          true,
        "w-[36px] h-[36px] min-w-[36px] min-h-[36px] text-[18px]":
          size === "36",
        "w-[24px] h-[24px] min-w-[24px] min-h-[24px] text-[14px]":
          size === "24",
        "border-interaction-primary": theme === "interaction",
        "border-creator-border": theme === "creator",
        "border-creator-primary": theme === "creator-selected",
        "bg-interaction-primary": !isNamedActor && theme === "interaction",
        "bg-creator-primary":
          !isNamedActor &&
          (theme === "creator" || theme === "creator-selected"),
        [actorColor]: isNamedActor,
      })}
    >
      {actor === undefined ? (
        <PersonOutlinedIcon color="inherit" fontSize="inherit" />
      ) : (
        initial
      )}
    </div>
  );
};

export default ActorAvatar;
